import { S as Swiper } from './index-DF38eFJP.js';
import './swiper-core-kdoF3145.js';
import './classes-to-selector-JYvn0qt6.js';

class FeaturedCollection extends HTMLElement {
  scrollbar = this.dataset.scrollbar === 'true';
  modules = [];

  async connectedCallback() {
    await this.loadModules();
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = Swiper(this, {
      modules: this.modules,
      slidesPerView: 2.22,
      spaceBetween: 16,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        hide: false,
        enabled: true,
        dragSize: 'auto',
        dragClass: 'swiper-scrollbar-drag',
      },
      breakpoints: {
        768: {
          slidesPerView: 4.29,
        },
        1440: {
          spaceBetween: 24,
          slidesPerView: 4.64,
        },
      },
    });
  }

  async loadModules() {
    if (this.scrollbar) {
      const { Scrollbar } = await import('./index-B1jj4H20.js');
      this.modules.push(Scrollbar);
    }
  }
}

customElements.define('featured-collection', FeaturedCollection);
